import { useTranslation } from 'react-i18next';

import RenderCard from './RenderCard';

const NameServers = ({ servers }: { servers: string[] }) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  return (
    <RenderCard
      title={t('nameServers.title')}
      value={servers}
      tooltip={t('nameServers.tooltip')}
      dataTestId="name-servers-card"
      showCopyIcon={true}
    />
  );
};

export default NameServers;
